import React from 'react';
import _ from 'lodash';

import SkillsLandingPage from '../../js/pages/SkillsLandingPage';
import {getTag} from '../../../server/services/tags';
import {getSkill} from '../../../server/services/cms/contentful';

export default function Page(props) {
  return <SkillsLandingPage {...props} />;
}

export async function getStaticProps({params}) {
  const tag = await getTag(params.skill);

  if (!tag || tag.type !== 'skill') {
    return {notFound: true};
  }

  const skill = await getSkill(params.skill);
  return {
    props: {tag, skill},
    revalidate: 3600,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
